import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { CategoryState } from 'store/category/types';

const setRecentlyViewedProductsReducer = (
  state: CategoryState,
  action: PayloadAction<AppBundle.Api.Response.Product.V1.RecentlyViewedProductListV1Response.RecentlyViewedItem[]>,
) => {
  state.recentlyViewedProducts = action.payload;
};

export default setRecentlyViewedProductsReducer;
